import React, { useState } from "react";
import { Blurhash } from "react-blurhash";
import "./BlurGalleryImage.scss";

const BlurGalleryImage = ({ item, activeGallerImages, onClick }) => {
  const [isLoaded, setIsLoaded] = useState(false);

  // 1. DYNAMIC ASPECT RATIO
  // Since you have width/height in DB, we force the container to this shape immediately.
  // This prevents the Masonry layout from collapsing or overlapping.

  const [ratio, setRatio] = useState(
    item.width && item.height ? item.width / item.height : null
  );

  // const containerStyle = {
  //   aspectRatio:
  //     item.width && item.height ? `${item.width} / ${item.height}` : "auto",
  // };
  const containerStyle = !isLoaded && ratio ? { aspectRatio: ratio } : {};

  // Determine wrapper classes
  const wrapperClasses = `gallery-image-wrapper ${
    activeGallerImages ? "is-active-selection" : ""
  }`;

  // Determine image classes
  const imgClasses = `gallery-real-img ${
    !activeGallerImages && !item.visibility ? "is-dimmed" : ""
  } ${isLoaded ? "is-visible" : "is-hidden"}`;

  return (
    // <div className={wrapperClasses} style={containerStyle} onClick={onClick}>
    <div
      className={`gallery-image-wrapper ${
        activeGallerImages ? "is-active-selection" : ""
      } ${isLoaded ? "is-loaded" : ""}`}
      style={containerStyle}
      onClick={onClick}
    >
      {/* --- BlurHash Layer (Z-Index: 0) --- */}
      {item.blurHash && (
        <div className={`blurhash-layer ${isLoaded ? "is-hidden" : ""}`}>
          <Blurhash
            hash={item.blurHash}
            width="100%"
            height="100%"
            resolutionX={32}
            resolutionY={32}
            punch={1}
          />
        </div>
      )}

      {/* --- Real Image (Z-Index: 1) --- */}
      <img
        src={item.src}
        alt="Gallery Item"
        loading="lazy"
        className={imgClasses}
        // onLoad={() => setIsLoaded(true)}
        onLoad={(e) => {
          setIsLoaded(true);
          if (!ratio) {
            const img = e.target;
            setRatio(img.naturalWidth / img.naturalHeight);
          }
        }}
      />
    </div>
  );
};

export default BlurGalleryImage;
